<template>
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0416 11.4H1.20156C0.841563 11.4 0.601562 11.64 0.601562 12C0.601562 12.36 0.841563 12.6 1.20156 12.6H11.0416L10.5616 13.08L10.4416 13.2L7.20156 18.12C6.96156 18.48 6.84156 18.96 6.96156 19.44C7.08156 19.92 7.32156 20.28 7.68156 20.64C7.92156 20.88 8.28156 21 8.76156 21H15.4816C16.4416 21 17.2816 20.16 17.2816 19.2C17.2816 18.84 17.1616 18.48 16.9216 18.12L13.5616 13.08V12.96L13.0816 12.48H22.8016C23.1616 12.48 23.4016 12.24 23.4016 11.88C23.4016 11.76 23.2816 11.52 23.0416 11.4ZM15.8416 18.84C15.9616 19.08 15.9616 19.32 15.8416 19.44C15.7216 19.68 15.6016 19.8 15.3616 19.8H8.64156C8.40156 19.8 8.28156 19.68 8.16156 19.44C8.04156 19.32 8.04156 19.08 8.16156 18.84L11.5216 13.8C11.6416 13.68 11.8816 13.56 12.0016 13.56C12.1216 13.56 12.2416 13.56 12.3616 13.68L12.4816 13.8L15.8416 18.84Z"
      fill="white"
    />
    <path
      d="M4.80156 0.600006C2.52156 0.600006 0.601562 2.52001 0.601562 4.80001C0.601562 7.08001 2.52156 9 4.80156 9C7.08156 9 9.00156 7.08001 9.00156 4.80001C9.00156 2.52001 7.08156 0.600006 4.80156 0.600006ZM4.80156 7.8C3.12156 7.8 1.80156 6.48001 1.80156 4.80001C1.80156 3.12001 3.12156 1.80001 4.80156 1.80001C6.48156 1.80001 7.80156 3.12001 7.80156 4.80001C7.80156 6.48001 6.48156 7.8 4.80156 7.8Z"
      fill="white"
    />
    <path
      d="M21.6 0.600006H16.8C15.84 0.600006 15 1.44001 15 2.40001V7.20001C15 8.16001 15.84 9 16.8 9H21.6C22.56 9 23.4 8.16001 23.4 7.20001V2.40001C23.4 1.44001 22.56 0.600006 21.6 0.600006ZM22.2 7.20001C22.2 7.56001 21.96 7.8 21.6 7.8H16.8C16.44 7.8 16.2 7.56001 16.2 7.20001V2.40001C16.2 2.04001 16.44 1.80001 16.8 1.80001H21.6C21.96 1.80001 22.2 2.04001 22.2 2.40001V7.20001Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "BalanceIcon",
};
</script>
